import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'delete-confirmation-modal',
  templateUrl: './deleteConfirmationModal.component.pug',
})
export class DeleteConfirmationModalComponent {
  @Input() text: string
  @Input() confirmation: string
  @Input() buttonText = this.translate.instant('Delete')
  input = ''

  constructor (private modalInstance: NgbActiveModal, private translate: TranslateService) { }

  get matches () {
    return this.confirmation.toLowerCase() === this.input.toLowerCase()
  }

  confirm () {
    if (this.matches) {
      this.modalInstance.close()
    }
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
